import HtmlParser from 'html-react-parser';
import React from 'react';
import Helmet from 'react-helmet';
import { DemoFormLong } from '../../components/DemoFormLong.jsx';
import SEO from '../../components/SEO';
import Layout from '../../layouts/index';
import { PATHS } from '../../utils/urls';

const Home = (props) => {
	const location = props.location;

	return (
		<Layout bodyClass="page-about" ontouchstart>
			<SEO title="About Us | ChartHop | The Org Management Platform" />
			<Helmet>
				<meta
					name="description"
					content="We're hiring! We're building ChartHop to support leaders in scaling transparent, productive and intentional organizations. Come join us."
				/>
				<meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
				<meta property="og:title" content="About Us | ChartHop | The Org Management Platform" />
				<meta property="og:description" content="We're hiring! We're building ChartHop to support leaders in scaling transparent, productive and intentional organizations. Come join us." />
				<meta property="og:image" content={`https://www.charthop.com/home/about-meta.png`} />
				<meta property="og:type" content="website" />
				<meta property="og:locale" content="en_US" />
        		<meta property="og:site_name" content="ChartHop" />
				{/* Twitter Card tags */}
				<meta name="twitter:title" content="About Us | ChartHop | The Org Management Platform" />
				<meta name="twitter:description" content="We're hiring! We're building ChartHop to support leaders in scaling transparent, productive and intentional organizations. Come join us." />
				<meta name="twitter:image" content={`https://www.charthop.com/home/about-meta.png`} />
				<meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />
			</Helmet>

			{/* HERO CONTENT */}
			<section className="text-center">
				<div className="hero-centerSectionSpacing">
					<div className="flex-centeredColumn">
						<h1 className="text-center title-1-secondary">We believe...</h1>
						<p className="text-center my-2 smallInMobile">
						People do their best work when they have full context.<br></br>
						To chart your future, you need to know where you came from.<br></br>
						A visual is worth a thousand spreadsheet cells.</p>
						<p className="smallInMobile">We're building ChartHop to support leaders in scaling <strong>transparent</strong>, <strong>productive</strong> and <strong>intentional</strong> organizations.</p>
					<a href="/company/careers/" rel="noopener noreferrer" target="_blank" className="button primary ">JOIN US</a>
					</div>
				</div>

			</section>

			{/* OUR TEAM
			<section className="backgroundGradientContainer sectionSpacing">
				<div className="col-md-12 text-center">
							<img src='/home/bunny.svg' alt="hop" />
							<h2 className="mb-2 mb-md-4">Our <span className="blue-text">hoppy</span> team</h2>

			
				<div className="d-flex flex-column sectionSpacing-Margin">
				<a href="/company/careers/" rel="noopener noreferrer" target="_blank"> <img className="imageBoxShaddow fullSegmentImage mx-auto" src={'/about/about-us-10-25-20.png'} alt="The ChartHop Team" /> </a>
				</div>
				<div className="d-flex flex-column">
					<a href="/company/careers/" rel="noopener noreferrer" target="_blank" className="ctaStandard text-center">Join us </a>
				</div>
				</div>

			</section> */}

			{/* OUR VALUES */}
			<section className="backgroundGradientContainer sectionSpacing">
				<div className="flex-centeredColumn contentBlock">
					<h2 className="text-center mb-md-4">Our values</h2>
					<div className="svg-info ">
						<div className="svg-info-card-3col ">
							<img src={'/about/ourValues/transparency_icon.svg'} alt="Transparency" />
							<h3>Own it and share it</h3>
							<p>We believe transparency and accountability go hand in hand.</p>
						</div>
						<div className="svg-info-card-3col">
							<img src={'/about/ourValues/clarity_icon.svg'} alt="Clarity" />
							<h3>Design practically</h3>
							<p>We find elegant solutions to very complex problems.</p>
						</div>
						<div className="svg-info-card-3col">
							<img src={'/about/ourValues/adaptability_icon.svg'} alt="Adaptibility" />
							<h3>Build for scalability</h3>
							<p >We're here for the long haul, and we optimize accordingly.</p>
						</div>
						<div className="svg-info-card-3col">
							<img src={'/about/ourValues/humanity_icon.svg'} alt="Humanity" />
							<h3>Lead with empathy</h3>
							<p>We support each other, our customers and our community.</p>
						</div>
						<div className="svg-info-card-3col">
							<img src={'/about/ourValues/protect_icon.svg'} alt="Protect" />
							<h3>Secure above all</h3>
							<p>We protect our customers' data like our lives depend on it.</p>
						</div>
						<div className="svg-info-card-3col">
							<img src={'/about/ourValues/truth_icon.svg'} alt="Truth" />
							<h3>Move intentionally</h3>
							<p>We move fast and we try not to break things.</p>
						</div>
					</div>
				</div>
			</section>

			

			{/* OUR SUPPORTERS */}
			<section className="text-center sectionSpacing">
				<div className="flex-centeredColumn">
					<h2 className="text-center mb-md-4">Our investors</h2>
					<div className="png-segment contentBlock">
						<div className="png-segment-wrap-first">
							<img src='/about/supporters/Andreessen_Horowitz.svg' alt="Andreessen Horowitz" />
						</div>
					</div>
					<div className="png-segment contentBlock">
						<div className="png-segment-wrap">
							<img src='/about/supporters/abstract-ventures-logo.svg' alt="Abstract ventures" />
						</div>
						<div className="png-segment-wrap">
							<img src='/about/supporters/flybridge.svg' alt="Flybridge" />
						</div>
						<div className="png-segment-wrap">
							<img src='/about/supporters/PeopleTech@2x.png' alt="PeopleTech" />
						</div>
						<div className="png-segment-wrap">
							<img src='/about/supporters/CowboyVentures@2x.png' alt="Cowboy Ventures" />
						</div>
						<div className="png-segment-wrap">
							<img src='/about/supporters/CoFound Logo - Rectangular Light Background@2x.png' alt="CoFound" />
						</div>
						<div className="png-segment-wrap">
							<img src='/about/supporters/shrug@2x.png' alt="Shrug" />
						</div>
						<div className="png-segment-wrap">
							<img src='/about/supporters/worklife_black@2x.png' alt="Worklife" />
						</div>
						<div className="png-segment-wrap">
							<img style={{maxWidth:"180px"}} src='/about/supporters/basement-fund-logo.png' alt="BasementFund" />
						</div>
						<div className="png-segment-wrap">
							<img style={{maxHeight:"150px", maxWidth:"180px"}} src='/supporters/ride-ventures-logo.png' alt="RideVentures" />
						</div>
						<div className="png-segment-wrap">
							<img src='/about/supporters/company-ventures-logo.png' alt="Worklife" />
						</div>
						<div className="png-segment-wrap">
							<img style={{maxWidth:"200px"}} src='/about/supporters/semper-virens-logo.png' alt="SemperVirens" />
						</div>
					</div>
					<p className="text-center caption-text">& 40+ founders and C-level executives</p>
					<a href={PATHS.INVESTORS} className="ctaStandard text-center">Learn more</a>
				</div>
			</section>

			{/* COMPANY EXPOSITION */}
			<section className="backgroundGradientContainer sectionSpacing">
				<div className="flex-centeredColumn contentBlock">
					<p className="segment-quote">“When people have the full context— know what they are trying to achieve together, know their roles, know the rules, and fundamentally trust that managers and leaders are transparent and fair — you can achieve great things.”</p>

					<div className="segment-author ">
						<div className="d-table-cell align-middle pr-1"><img src={'/about/ian_photo@2x.png'} alt="Ian White" /></div>
						<div className="d-table-cell align-middle"> <strong>Ian White,</strong> CEO</div>
					</div>


					<p className="text-center">
						Learn more about why Ian started ChartHop <a className="blue-text" href="/blog/company-updates/why-i-built-this/">here.</a>
					</p>

				</div>
			</section>

			{/* WE'RE HIRING */}
			<section className="sectionSpacing sectionSpacingCenter">
				<div className="textContent">
					<img src={'/home/bunny.svg'} alt="ChartHop logo" />
					<div>
						<h2 className="stillH1">Join our team</h2>
						<p>Let's build the best People software on the planet, together.</p>
					</div>
				</div>
				<div className="buttonContent">
					<a className="button primary" rel="noopener noreferrer" target="_blank" href="/company/careers/">SEE JOB OPENINGS</a>
				</div>
			</section>

			{/* LONG FORM */}

			<section name="request-demo" id="request-demo" className="request-demo sectionSpacing">
                <DemoFormLong source={"company-about-demo-bottom"} headertext={HtmlParser("<h2>We'd love to show you what we're building.<br/><br/>Request a demo!</h2>")}/>
            </section>

			
		</Layout>
	);
};


export default Home;